import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LinkedinRegular from './linkedin-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LinkedinRegular {...validProps} />;
}
SvgComponent.iconName = 'linkedinRegular';

export const LinkedinRegularIcon = svgIconWrapper(SvgComponent);
